export default __webpack_public_path__ + "static/media/plus-solid-space-cadet.c580d54d.png";